import Carousel from "../components/Carousel"
import Footer from "../components/Footer"
import Navbar from "../components/Navbar"
import ProductCard from "../components/ProductCard"
import ServiceCard from "../components/ServiceCard"
import "../Styles/Home.css"
import orange from "../assets/images/orange.png"
import grains from "../assets/images/grains.png"
import legumes from "../assets/images/legumes.png"
import meat from "../assets/images/meat.png"
import seafood from "../assets/images/seafood.png"
import vegetables from "../assets/images/vegetables.png"
import fruit from "../assets/images/fruits.jpg"
import veg from "../assets/images/veggeis.jpg"
import { useEffect, useState } from "react"
import { url } from "../db/url"
import axios from "axios"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"



const Home = () => {
    const [product, setProduct] = useState([])
    const naviagte = useNavigate()

    useEffect(() => {
        axios.get(`${url}/api/v2/product/get-all-products`)
        .then(res => {
            console.log(res.data.products)
            setProduct(res.data.products)
        }).catch(err => {
            console.log(err)
            toast.error(err.response ? err.response.data.message : "Network Error")
        })
    }, [])

    return <>
        <Navbar/>
        <Carousel/>

        <div className="homeWrapper">
            <div className="categories">
                <h2>Categories</h2>
                <div className="categoryCardWrapper">
                    <div className="categoryCard">
                        <img src={orange} alt="" />
                        <p>Fruits</p>
                    </div>
                    <div className="categoryCard">
                        <img src={vegetables} alt="" />
                        <p>Vegetables</p>
                    </div>
                    <div className="categoryCard">
                        <img src={grains} alt="" />
                        <p>Grains</p>
                    </div>
                    <div className="categoryCard">
                        <img src={legumes} alt="" />
                        <p>Legumes</p>
                    </div>
                    <div className="categoryCard">
                        <img src={meat} alt="" />
                        <p>Meat</p>
                    </div>
                    <div className="categoryCard">
                        <img src={seafood} alt="" />
                        <p>Seafood</p>
                    </div>
                </div>
            </div>

            <div className="trending">
                <h2>Trending Products</h2>
                <div className="trendingCardWrapper">
                {
                    product.slice(0, 12).map((data, index) => {
                        return(
                            <div className="card" key={index}>
                                <ProductCard 
                                    img={data.images && data.images[0].url}
                                    name={data.name}
                                    prevPrice={data.originalPrice}
                                    price={data.discountPrice}
                                    rating={data.ratings}
                                />
                            </div>
                        )
                    })
                }
                </div>
                <button onClick={() => naviagte('/product')}>Shop Now</button>
            </div>

        </div>
            <div className="banner">
                <div className="leftBanner">
                    <h1>Christmas Discount</h1>
                    <p>Come back december 20th to get 50$ discount on all agricultural purchases from our store, lasting from 20th december to 25th december</p>
                    <img src={fruit} alt="" />
                </div>
                <div className="rightBanner">
                    <img src={veg} alt="" />
                </div>
            </div>
            <div className="homeWrapper">
                <div className="trending">
                    <h2>Popular Picks</h2>
                    <div className="trendingCardWrapper">
                    {
                        product.slice(12, 24).map((data, index) => {
                            return(
                                <div className="card" key={index}>
                                    <ProductCard 
                                        img={data.images && data.images[0].url}
                                        name={data.name}
                                        prevPrice={data.originalPrice}
                                        price={data.discountPrice}
                                        rating={data.ratings}

                                    />
                                </div>
                            )
                        })
                    }
                    </div>
                    <button onClick={() => naviagte('/product')}>Shop Now</button>
                </div>
            </div>

        <ServiceCard/>
        <div className="space"></div>
        <Footer/>

    </>

}

export default Home